export const INIT_CONSENT_LIST = '[CONSENT][INIT][LIST]';
export const GET_CONSENT_SUCCESS = '[CONSENT][GET]';
export const SET_CURRENT_PAGE = '[CONSENT][SET][PAGE]';
export const SET_CURRENT_PAGE_READ = '[CONSENT][SET][PAGE][READ]';
export const TOGGLE_CONSENT = '[CONSENT][TOGGLE]';
